export function isCnorderOid (oid) {
  return String(oid || '').startsWith('C')
}
